import React, { FC } from 'react';
import './TextAreaField.css';
import { ErrorMessage, Field } from 'formik';

interface TextAreaFieldProps {
	label: string,
	name: string,
	placeholder?: string,
	rows?: number,
	required? : boolean
}

const TextAreaField: FC<TextAreaFieldProps> = ({ label, name, placeholder, rows = 4, required = false }) => (

	<label className="TextAreaField data-field-label" data-testid="TextAreaField">
		<div>{label} {required && <span className="asterisk" aria-hidden="true"> *</span>}</div>
		<div className="form-group">
			<div className='Field-wrapper'>
				<Field
					as="textarea"
					name={name}
					className="textarea-field"
					placeholder = {placeholder || name}
					rows = {rows}
				>
				</Field>
			</div>
			<ErrorMessage name={name} component="div" className="error-message" />
		</div>
	</label>
);

export default TextAreaField;
